// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chat-conversation-rename-dialog .conversation-new-name-input {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation/fi-chat-conversation-rename-dialog/fi-chat-conversation-rename-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR","sourcesContent":[".fi-chat-conversation-rename-dialog {\r\n    .conversation-new-name-input {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
